/**
 * Read-only accessors for raw AI rule responses.
 */
export function getConditions(rawRule) {
    return rawRule.conditions.and;
}
export function getActions(rawRule) {
    return rawRule.conditions.result.value;
}
export function getAppliedCategory(rawRule) {
    return rawRule.conditions.result.value.find((action) => action.actionType === 'set_category')?.actionValue;
}
